<template>
    <div>
      <div class="trad_topContent">
        <div class="trad_topContentCenter">
          <div class="e-flex trad_menuContent">
            <img class="ic_home" src="@/assets/images/ic_home.png">
            <div class="pointer" @click="goMainPage()">首页</div>
            <div>/</div>
            <div class="pointer" @click="$router.push({ path: '/twoRegionActivity/index', query: {}})">两区活动</div>
            <div>/</div>
            <div>正文</div>
          </div>
          <div class="e-flex trad_topContentCenterInfo">
            <div class="e-flex trad_topContentCenterWhite">
              <img class="trad_activityImg" :src="info.thumbUrl">
              <div class="trad_topContentCenterWhiteRight">
                <div class="trad_activityTitle e-line-2">{{ info.title }}</div>
                <div class="trad_activityBaseInfo">
                  <div>时间：{{ info.startTime ? info.startTime.slice(0,16) : '' }} 至 {{ info.endTime ? info.endTime.slice(0,16) : '' }}</div>
                  <div>地点：{{ info.place }}</div>
                  <div>人数：{{ info.people < 1 ? '不限' : info.people }}</div>
                </div>
                <div :class="info.process == 0 ? 'trad_activityBtn' : 'trad_activityGryBtn'" @click="openDialog()" style="cursor: pointer;">立即报名</div>
              </div>
              <div :class="'trad_activityStatus ' + ('trad_activityStatus' + info.process)">{{info.process == 0 ? '未开始' : (info.process == 1 ? '已开始' : '已结束')}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="e-flex trad_activityCommonContent">
        <div class="trad_activityCommonContentCenter">
          <div class="trad_activityCommonTitle">活动详情</div>
          <div class="trad_activityCommonText" v-html="info.content"></div>
        </div>
      </div>
      
      <el-dialog title="" :visible.sync="applyVisible" width="7.5rem" :close-on-click-modal="false">
          <div class="">
            <div class="trad_dialogTitle">填写报名信息</div>
            <div class="trad_dialogListInfo">
              <div class="trad_dialogBlueList" v-for="(item, index) in applyList">
                <div class="e-flex trad_dialogList">
                  <div class="trad_mustFlag">*</div>
                  <div class="trad_dialogLabel">企业名称</div>
                  <div class="trad_dialogELe e-flex">
                    <el-input v-model="item.company" placeholder="请输入企业名称"></el-input>
                  </div>
                </div>
                <div class="e-flex trad_dialogList">
                  <div class="trad_mustFlag">*</div>
                  <div class="trad_dialogLabel">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</div>
                  <div class="trad_dialogELe e-flex">
                    <el-input v-model="item.name" placeholder="请输入姓名"></el-input>
                  </div>
                </div>
                <div class="e-flex trad_dialogList">
                  <div class="trad_mustFlag">*</div>
                  <div class="trad_dialogLabel">联系方式</div>
                  <div class="trad_dialogELe e-flex">
                    <el-input v-model="item.phone" placeholder="请输入联系方式"></el-input>
                  </div>
                </div>
                <div class="e-flex trad_dialogList">
                  <div class="trad_mustFlag">*</div>
                  <div class="trad_dialogLabel">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务</div>
                  <div class="trad_dialogELe e-flex">
                    <el-input v-model="item.duty" placeholder="请输入职务"></el-input>
                  </div>
                </div>
                <div class="e-flex trad_dialogList">
                  <div class="trad_mustFlag"></div>
                  <div class="trad_dialogLabel">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注</div>
                  <div class="trad_dialogELe e-flex">
                    <el-input v-model="item.comment" placeholder="请输入备注"></el-input>
                  </div>
                </div>
              </div>
              <div class="addApplyPeopleBtn" @click="addPeople()">+添加报名人</div>
            </div>
            <div class="trad_updateContent e-flex">
              <div class="updateBtn" @click="updateData()" style="cursor: pointer;">提交</div>
            </div>
          </div>
        </el-dialog>

        <el-dialog title="" :visible.sync="applySuccessVisible" width="5.625rem" :close-on-click-modal="false" :show-close="false">
          <div class="" style="text-align: center;padding-bottom: 40px;">
            <img class="ic_success" src="@/assets/images/ic_success.png">
            <div class="applySuccessContent">报名成功</div>
            <div class="applySuccessBtn" @click="applySuccessVisible = false">返回上一级</div>
          </div>
        </el-dialog>
        <el-dialog title="" :visible.sync="loginVisible" width="12.916666666666666rem" :close-on-click-modal="false">
          <div class="e-flex loginContent">
            <img class="loginImg" src="@/assets/images/loginImg.png">
            <div class="loginContentRight">
              <div class="loginContentTitle">欢迎登录</div>
              <div class="loginFormContent">
                <div class="trad_loginELe e-flex">
                  <el-input v-model="loginForm.phone" placeholder="请输入手机号"></el-input>
                </div>
                <div class="trad_loginELe e-flex">
                  <el-input v-model="loginForm.code" placeholder="请输入验证码"></el-input>
                  <div class="getCodeBtn" @click="getCode()">{{ codeName }}</div>
                </div>
              </div>
              <div class="trad_loginBtn" @click="login()" style="cursor: pointer;">登录</div>
            </div>
          </div>
        </el-dialog>

    </div>
</template>
  
  <script>
    import '../../styles/twoRegionActivity.css'
    export default {
      name: 'twoRegionActivityDetail',
      data () {
        return {
          applyVisible: false,
          applySuccessVisible: false,
          applyList: [{
            company: '',
            name: '',
            phone: '',
            duty: '',
            comment: ''
          }],
          id: '',
          info: {},
          loginVisible: false,
          loginForm: {
            phone: '',
            code: ''
          },
          user: null,
          codeName: '获取验证码',
          n: 180,
        }
      },
      created() {
        this.user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : ''
        this.id = this.$route.query.id
        this.getDetail()
      },
      methods: {
        openDialog() {
          if (!this.user) {
            this.loginVisible = true
            return
          }
          if (this.info.process != 0) {
            this.$message({
              message: '活动报名已结束',
              type: 'warning'
            });
            return
          }
          this.applyList = [{
            company: '',
            name: '',
            phone: '',
            duty: '',
            comment: ''
          }]
          this.applyVisible = true
        },
        addPeople() {
          this.applyList.push({
            company: '',
            name: '',
            phone: '',
            duty: '',
            comment: ''
          })
        },
        updateData() {
          this.request({
              url: 'activity/apply',
              method: 'post',
              data: {
                activityId: this.id,
                userId: this.user.id ? this.user.id : this.user.data.id,
                applyList: this.applyList
              }
          }).then(res => {
            if (res.code != 1) {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
              return
            }
            this.applyVisible = false
            this.applySuccessVisible = true
          })
          
        },
        goMainPage() {
          this.$emit('goNavPage', {
            key:'1',
            path: ['1'],
            pathId: '1'
          })
        },
        getDetail() {
          this.request({
              url: 'activity/detail',
              method: 'post',
              data: {
                id: this.id
              }
          }).then(res => {
              // let dateStramp = new Date().getTime()
              // let startStamp = new Date(res.data.startTime.slice(0,19)).getTime()
              // let endStamp = new Date(res.data.endTime.slice(0,19)).getTime()
              // if (dateStramp < startStamp) { // 未开始
              //   res.data.activityStatus = 0
              // } else if (dateStramp > startStamp && dateStramp < endStamp) { // 已开始
              //   res.data.activityStatus = 1
              // } else if (dateStramp > endStamp) { // 已结束
              //   res.data.activityStatus = 2
              // }
              this.info = res.data
          })
        },
        login() {
          this.request({
              url: 'user/login',
              method: 'POST',
              data: {
                mobile:this.loginForm.phone,
                code:this.loginForm.code
              }
          }).then(res => {
            if (res.code == 1) {
              localStorage.setItem('user', JSON.stringify(res.data));
              this.user = res.data
              this.loginVisible = false
              this.applyList = [{
                company: '',
                name: '',
                phone: '',
                duty: '',
                comment: ''
              }]
              this.applyVisible = true
              this.$emit('pageLogin', {})
            }
          })
        },
        getCode() {
          if (!this.loginForm.phone) {
            this.$message({
              message: '请填写手机号',
              type: 'warning',
              iconClass: 'none'
            });
            return
          }
          if (this.codeName != '获取验证码') {
            this.$message({
              message: '请勿重复获取',
              type: 'warning',
              iconClass: 'none'
            });
            return
          }
          this.request({
              url: 'user/getCode',
              method: 'POST',
              data: {
                mobile: this.loginForm.phone
              }
          }).then(res => {
              if (res.code == 1) {
                this.$message({
                    message: '验证码已发送',
                    type: 'success',
                    iconClass: 'none'
                });
                if (this.n >= 0) {
                  this.codeName = this.n + ' s'
                  let interval = setInterval(() => {
                    if (this.n == 0) {
                      this.codeName = '获取验证码'
                      this.n = 180
                      clearInterval(interval)
                      return
                    }
                    this.n = this.n - 1
                    this.codeName = this.n + ' s'
                  },1000)
                } else {
                  this.codeName = '获取验证码'
                }
              }
          })
        },
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/twoRegionActivity/detail.vue